// extracted by mini-css-extract-plugin
module.exports = {"root":"e_fA","lead":"e_gA","buttons":"e_hA","primary":"e_iA","fine":"e_jA","error":"e_kA","inline":"e_lA","inlineButton":"e_mA","list":"e_nA","question":"e_oA"};